/*
 * Created on Thu July 2025
 *
 * Copyright (c) 2025 - Mike Hauber <mhauber@gmail.com>
 */
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../_services/authentication.service.js';

@Component({
  selector: 'app-videoplayer',
  templateUrl: './videoplayer.component.html',
  styleUrls: ['./videoplayer.component.css']
})
export class VideoplayerComponent implements OnInit {
  isLoggedIn: boolean = false;
  videoUrl: string = 'assets/video/test-video.mp4'; // local test video

  constructor(private authService: AuthenticationService) {}
 
  ngOnInit(): void {
 // Check if the user is logged in
  this.isLoggedIn = !!this.authService.get_user();
 }
}